import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-view-transaction-log',
  templateUrl: './view-transaction-log.component.html',
  styleUrls: ['./view-transaction-log.component.scss']
})
export class ViewTransactionLogComponent implements OnInit {

  @Output() closeActivityAtDialog: EventEmitter<any> = new EventEmitter();


  isLoading: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<ViewTransactionLogComponent>,
    public appService: AppService,
    public routes: ActivatedRoute, private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    console.log(data);

  }
  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
    this.closeActivityAtDialog.emit(null);
  }
}
